module.exports = __webpack_public_path__ + "static/img/talking-data-logo.fd42d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/talking-data-logo.png
// module id = Nj6u
// module chunks = 0